import { StyleSheet } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  background: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo,
    marginTop: 20
  }),
  boldText: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.h4,
    paddingHorizontal: 10,
    marginVertical: 10
  },
  countriesContainer: {
    paddingTop: 10,
    marginHorizontal: 10
  },
  countryContainer: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // marginVertical: 5,
    borderBottomColor: theme.isDark ? '#333333' : Colors.white_two,
    borderBottomWidth: 1,
    paddingVertical: 10
  }),
  country: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 10
  },
  countryText: {
    ...Fonts.type.normal,
    fontSize: Fonts.size.h5
  },
  selectedBackground: theme => ({
    backgroundColor: theme.isDark ? '#333333' : Colors.white_two,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // marginTop: -5,
    borderBottomColor: theme.isDark ? '#333333' : Colors.white_two,
    borderBottomWidth: 1,
    paddingVertical: 10,
    marginHorizontal: -10,
    paddingHorizontal: 10
  }),
  marginRight30: {
    marginRight: 30
  },
  inputText: {
    color: 'rgba(102, 102, 102, 1)'
  }
})

export default styles
